"use client";

import { SiteNav } from "@/components/site/site-nav";
import { SiteFooter } from "@/components/site/site-footer";
import { DocsPage } from "@/components/site/docs-page";

// Stub — ported as-is from the v0 export (ai-dubbing-studio_2.zip), not yet
// wired to real content. Placeholder only, per owner's request 2026-07-26.
export default function Docs() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <SiteNav />
      <DocsPage />
      <SiteFooter />
    </div>
  );
}
